import request from '@/utils/request'
import exportRequest from '@/utils/export'

export function meeting(query) {
  return request({
    url: 'meeting',
    method: 'post',
    data: query
  })
}

export function meetingtype(query) {
  return request({
    url: 'type/search',
    method: 'post',
    data: query
  })
}

export function meetingupdate(query, id) {
  return request({
    url: 'meeting/update/' + id,
    method: 'post',
    data: query
  })
}
export function meetingupdateOngoing(query, id) { // 进行中的任务调的接口不一样
  return request({
    url: '/meeting/startingEdit/' + id,
    method: 'post',
    data: query
  })
}

export function meetings(query) {
  return request({
    url: 'room/meetings',
    method: 'post',
    data: query
  })
}

export function meetingsearch(query) {
  return request({
    url: 'meeting/search',
    method: 'post',
    data: query
  })
}
export function attendees(query) {
  return request({
    url: 'attendees/refuse',
    method: 'post',
    data: query
  })
}

export function attendeesleave(query) {
  return request({
    url: 'attendees/leave',
    method: 'post',
    data: query
  })
}

export function meetingroom(query) {
  query.room_status = 1
  return request({
    url: 'room/search',
    method: 'post',
    data: query
  })
}

export function meetingroomID(id) {
  return request({
    url: '/room/' + id,
    method: 'get'
  })
}

export function roomData() {
  return request({
    url: '/room/all',
    method: 'get'
  })
}
// 导出异常清单
export function downloadData(params) {
  return exportRequest({
    url: '/meeting/exportMeeting',
    method: 'post',
    data: params
  })
}
